/**
 * Growth Indicator — visual plant/tree growth per day.
 * Shows lola (tulip) for female, xurmo (palm) for male.
 * Images at 5 stages: 20%, 40%, 60%, 80%, 100% completion.
 * Vite-imported WebP — all <64KB = base64 inline = instant load.
 */

import React from 'react'

import lola20 from '../../../assets/plants/lola-20.jpg'
import lola40 from '../../../assets/plants/lola-40.jpg'
import lola60 from '../../../assets/plants/lola-60.jpg'
import lola80 from '../../../assets/plants/lola-80.jpg'
import lola100 from '../../../assets/plants/lola-100.jpg'
import xurmo20 from '../../../assets/plants/xurmo-20.jpg'
import xurmo40 from '../../../assets/plants/xurmo-40.jpg'
import xurmo60 from '../../../assets/plants/xurmo-60.jpg'
import xurmo80 from '../../../assets/plants/xurmo-80.jpg'
import xurmo100 from '../../../assets/plants/xurmo-100.jpg'

const LOLA = [lola20, lola40, lola60, lola80, lola100] as const
const XURMO = [xurmo20, xurmo40, xurmo60, xurmo80, xurmo100] as const
const THRESHOLDS = [20, 40, 60, 80, 100] as const

function getPlantImage(gender: 'male' | 'female', rate: number): string | null {
  if (rate <= 0) return null
  const images = gender === 'female' ? LOLA : XURMO
  const idx = THRESHOLDS.findIndex((t) => rate <= t)
  return images[idx === -1 ? 4 : idx]
}

interface GrowthIndicatorProps {
  day: number
  year: number
  month: number
  completionRate: number
  gender: 'male' | 'female'
}

export const GrowthIndicator: React.FC<GrowthIndicatorProps> = React.memo(({
  completionRate, gender,
}) => {
  const imageSrc = getPlantImage(gender, completionRate)

  return (
    <div className="h-20 flex items-end justify-center pb-0.5">
      {imageSrc ? (
        <img
          src={imageSrc}
          alt=""
          className="object-contain"
          style={{ height: '72px', maxWidth: '40px' }}
          draggable={false}
        />
      ) : (
        <div className="w-1 h-1 rounded-full bg-white/[0.08]" />
      )}
    </div>
  )
})

GrowthIndicator.displayName = 'GrowthIndicator'
